import React from "react";
import Hero from "components/hero";
import styles from "./page.module.scss";

import FooterCta from "components/footer-cta";
import ErrorPage from "components/error-page";
import Blocks from "blocks";
import usePage from "./usePage";
import LocationMap from "blocks/location-map";

const Page = ({ match }) => {
  const { loading, error, data } = usePage({ uri: match.url.replace("/", "") });

  if (loading) {
    return <ErrorPage type="loading" />;
  }

  if ((error && !data) || !data) {
    console.log(error);
    return <ErrorPage type="500" />;
  }

  if (data && !data.entry) {
    return <ErrorPage type="404" />;
  }

  switch (data.entry.typeHandle) {
    case "page":
      return (
        <article>
          <Hero
            heading={data.entry.heroHead}
            copy={data.entry.headSubhead}
            image={data.entry.heroImage}
          />
          <Blocks blocks={data.entry.pageBuilder} entry={data.entry} />
          <FooterCta current={data.entry.id} />
        </article>
      );
    case "simplePage":
      return (
        <article>
          <h1 className={styles.heading}>{data.entry.heading}</h1>
          {data.entry.pageBuilder ? (
            <Blocks
              blocks={data.entry.pageBuilder}
              entry={data.entry}
              className={"simple"}
            />
          ) : null}
          <FooterCta current={data.entry.id} />
        </article>
      );
    case "locale":
      console.log(data.entry);
      const resourceType = data.entry.resourceType;

      return (
        <article>
          <Hero
            heading={data.entry.title}
            copy={data.entry.copy}
            image={data.entry.image}
          />
          {/* <nav className={styles.pageNav}>
            <h2>On this page:</h2>
            <ul>
              <a href="#help">Get Help</a>
              <a href="#information">Get Informed</a>
            </ul>
          </nav> */}
          <Section id="help" heading="Where can you find legal help?">
            <div className={styles.container}>
              <p className={styles.helpSubheading}>
                Get the help of a social worker, parent advocate or lawyer:
              </p>
              {resourceType === "nycMap" ? (
                <LocationMap noPad />
              ) : (
                data.entry.resourceOrganizations.map(
                  ({
                    id,
                    title,
                    logo,
                    address,
                    email,
                    phoneNumber,
                    website,
                  }) => {
                    return (
                      <div key={id} className={styles.organization}>
                        {logo && logo.length > 0 && (
                          <img
                            // className={styles.svg}
                            src={logo[0].url}
                            width={logo[0].width}
                            height={logo[0].height}
                            alt={logo[0].alt}
                          />
                        )}
                        <h3>{title}</h3>
                        {address && (
                          <div dangerouslySetInnerHTML={{ __html: address }} />
                        )}
                        {email && <a href={`mailto:${email}`}>{email}</a>}
                        {phoneNumber && (
                          <a href={phoneNumber.url}>
                            {phoneNumber.defaultLabel}
                          </a>
                        )}
                        {website && <a href={website}>{website}</a>}
                      </div>
                    );
                  },
                )
              )}
            </div>
          </Section>
          <Section id="information" heading="Get Informed">
            <Blocks blocks={data.entry.pageBuilder} entry={data.entry} />
          </Section>
        </article>
      );
    default:
      return null;
  }
};

export default Page;

function Section({ heading, id, children }) {
  return (
    <section id={id} className={styles.section}>
      <h2 className={styles.sectionHeading}>{heading}</h2>
      {children}
    </section>
  );
}
